// import React, { useEffect } from 'react';
// // import { useFileContext } from '../../../../Contexts/FileContext';
// // import ssoImg1 from "./../../../../assets/images/checklists-form-img.png";
// import pdfIcon from "./../../assets/images/pdf.png";
// import ssoImg1 from "./../../assets/images/checklists-form-img.png";
// import { WebApiURL } from './../../Constants/Constants';
// // import { useFileContext } from './../../Constants/FileContext';
// import { useFileContext } from './../../Contexts/FileContext';
// import { FaFilePdf } from "react-icons/fa";

// function CancelledTenders() {
//   const {
//     setComponentName,
//     documents,
//     loading,
//     setSection
//   } = useFileContext();

//   useEffect(() => {
//     setComponentName("ALL FORMS");
//     setSection("");
//   }, [setComponentName]);

//   const groupedDocs = documents.reduce((acc, doc) => {
//     const folder = doc.folderName || 'Uncategorized';
//     if (!acc[folder]) acc[folder] = [];
//     acc[folder].push(doc);
//     return acc;
//   }, {});


//   return (
//     <>
//       <div className="service-title font-700 mb-3 text-uppercase">
//         Cancelled
//         <span className="text-orange-ef3e33 font-400"> Tenders </span>
//       </div>

//       <div className="row g-3 g-sm-4 g-md-4">
//         <div className="col-12">
//           <div className="accordion blackTab" id="blackTab">
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab1"
//                   aria-expanded="true"
//                   aria-controls="blackTab1"
//                 >
//                   SAMSA/099/2024/25 REQUEST FOR PROSPECTIVE BIDDERS TO SUBMIT A PROPOSAL
//                 </button>
//               </h2>
//               <div
//                 id="blackTab1"
//                 className="accordion-collapse collapse show"
//                 data-bs-parent="#blackTab"
//               >
//                 <div className="accordion-body">
//                   <div className="row g-3">
//                     <div className="col-md-12">
//                       {/* <p className="mb-3">
//                         <b className="d-block">Name ​of Institution </b>
//                         <strong>​​​South A​​frican Maritime Safety Authority (SAMSA)​ ​ </strong>
//                         ​
//                         </p> */}
//                       <p className="mb-3">
//                         <b className="d-block">​Description </b>
//                         Cancellation notice: Request for prospective bidders to submit a proposal for comprehensive security guarding solution for the SAMSA head office for period of three (3) years five moths commencing on 01 march until 31 July 2028
//                       </p>
//                       <p className="mb-3">
//                         <a href="/Documents/SAMSA-110-2025-26_Panel-of-Researchers-Final.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                           <FaFilePdf style={{ marginRight: "5px" }} />SAMSA-110-2025-26_Panel of Researchers Final.pdf
//                         </a>
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Bid number</b>
//                         SAMSA/099/2024/25
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Advert date</b>

//                       </p>

//                       <p className="">
//                         <b className="d-block">Closing Date</b>
//                         04 November 2024 at 11H00 a.m.
//                       </p><br />

//                       <p className="">
//                         <b className="d-block">LOCATION: SAMSA HEAD OFFICE</b>
//                         0146 Lunnon Road<br />Cnr Jan Shoba & Lunnon Road<br />HILLCREST<br />PRETORIA<br />0183
//                       </p>
//                       <p className=""><br />
//                         <ul className="trust">
//                           <li>The following changes were made to the tender document that was published on e-portal and SAMSA website:
//                             <ul className="star-li">
//                               <li>
//                                 The pricing schedules were amended to include the full scope of work
//                               </li>
//                               <li>Mandatory item (A) was amended to include other means of evidence for UIF</li>
//                               <li>Mandatory item (G) was amended to include option of leasing the ICASA equipment</li>
//                               <li>Amendments under Technical evaluation (Phase 4) - Points allocated for reference letters changed to 60</li>
//                               <li>Amendments under Technical evaluation (Phase 4) - Points allocated for Team capability changed to 40</li>
//                               <li>Amendments under Technical evaluation (Phase 4) – Note number 3 added under Team capability to clarify the experience criteria.</li>
//                               <li>Closing date of tender extended from 21 October 2024 to 04 November 2024.</li>


//                             </ul>
//                           </li>
//                         </ul></p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab2"
//                   aria-expanded="false"
//                   aria-controls="blackTab2"
//                 >
//                   SAMSA/087/2023/24 APPOINTMENT OF A PANEL OF SERVICE PROVIDERS
//                 </button>
//               </h2>
//               <div
//                 id="blackTab2"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//               <div className="accordion-body">
//                   <p className="mb-3">
//                         <b className="d-block">​Description</b>
//                         THE APPOINTMENT OF A PANEL SERVICE PROVIDERS (SUPPLIERS) TO PROVIDE SAMSA MARITIME SPECIAL PROJECTS WITH DIESEL (ADO-AUTOMOTIVE DIESEL OIL) 50PPM ON SERVICES FOR A PERIOD NOT EXCEEDING 26 OCTOBER 2026 ON BEHALF OF MLRF FOR CAPE TOWN
//                       </p>
//                       <p className="mb-3">
//                         <a href="/Documents/SAMSA-110-2025-26_Panel-of-Researchers-Final.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                           <FaFilePdf style={{ marginRight: "5px" }} />SAMSA-110-2025-26_Panel of Researchers Final.pdf
//                         </a>
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Bid number</b>
//                         SAMSA/087/2023/24
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Advert date</b>

//                       </p>

//                       <p className="">
//                         <b className="d-block">Closing Date</b>
//                         31/01/2024 at 11H00 a.m
//                       </p>

//                       <p className=""><br />
//                         <b className="d-block">LOCATION: SAMSA HEAD OFFICE</b>
//                         0146 Lunnon Road<br />Cnr Jan Shoba & Lunnon Road<br />HILLCREST<br />PRETORIA<br />0183
//                       </p>

//                     </div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab3"
//                   aria-expanded="false"
//                   aria-controls="blackTab3"
//                 >
//                   SSAMSA/089/2023/24 APPOINTMENT OF A PANEL OF SERVICE PROVIDERS TO PROVIDE SAMSA MARITIME
//                 </button>
//               </h2>
//               <div
//                 id="blackTab3"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//               <div className="accordion-body">
//                   <p className="mb-3">
//                         <b className="d-block">​Description</b>
//                         Cancellation notice: Request for prospective bidders to submit a proposal for comprehensive security guarding solution for the SAMSA head office for period of three (3) years five moths commencing on 01 march until 31 July 2028
//                       </p>
//                       <p className="mb-3">
//                         <a href="/Documents/SAMSA-110-2025-26_Panel-of-Researchers-Final.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                           <FaFilePdf style={{ marginRight: "5px" }} />SAMSA-110-2025-26_Panel of Researchers Final.pdf
//                         </a>
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Bid number</b>
//                         SAMSA/0892023/24
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Advert date</b>

//                       </p>

//                       <p className="">
//                         <b className="d-block">Closing Date</b>
//                         31/01/2024 at 11H00 a.m.
//                       </p>

//                       <p className="">
//                         <b className="d-block">LOCATION: SAMSA HEAD OFFICE</b><br />
//                         0146 Lunnon Road<br />Cnr Jan Shoba & Lunnon Road<br />HILLCREST<br />PRETORIA<br />0183
//                       </p>

//                     </div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab4"
//                   aria-expanded="false"
//                   aria-controls="blackTab4"
//                 >
//                   SAMSA/088/2023/24 APPOINTMENT OF A PANEL OF SERVICE PROVIDERS TO PROVIDE SAMSA MARITIME
//                 </button>
//               </h2>
//               <div
//                 id="blackTab4"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//               <div className="accordion-body">
//                   <p className="mb-3">
//                         <b className="d-block">​Description</b>
//                         THE APPOINTMENT OF A PANEL SERVICE PROVIDERS (SUPPLIERS) TO PROVIDE SAMSA MARITIME SPECIAL PROJECTS WITH DIESEL (ADO-AUTOMOTIVE DIESEL OIL) 50PPM ON SERVICES FOR A PERIOD NOT EXCEEDING 26 OCTOBER 2026 ON BEHALF OF MLRF FOR DURBAN.
//                       </p>
//                       <p className="mb-3">
//                         <a href="/Documents/SAMSA-110-2025-26_Panel-of-Researchers-Final.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                           <FaFilePdf style={{ marginRight: "5px" }} />SAMSA-110-2025-26_Panel of Researchers Final.pdf
//                         </a>
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Bid number</b>
//                         SAMSA/0892023/24
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Advert date</b>

//                       </p>

//                       <p className="">
//                         <b className="d-block">Closing Date</b>
//                         31/01/2024 at 11H00 a.m
//                       </p>

//                       <p className="">
//                         <b className="d-block">LOCATION: SAMSA HEAD OFFICE</b><br />
//                         0146 Lunnon Road<br />Cnr Jan Shoba & Lunnon Road<br />HILLCREST<br />PRETORIA<br />0183
//                       </p>

//                     </div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab5"
//                   aria-expanded="false"
//                   aria-controls="blackTab5"
//                 >
//                   SAMSA/088/2023/24 APPOINTMENT OF A PANEL OF SERVICE PROVIDERS TO PROVIDE SAMSA MARITIME
//                 </button>
//               </h2>
//               <div
//                 id="blackTab5"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//               <div className="accordion-body">
//                   <p className="mb-3">
//                         <b className="d-block">​Description</b>
//                         SAMSA-098-2023-24THE-APPOINTMENT OF AN ACCREDITED SERVICE PROVIDERS FOR THE PROVISION AND RENEWAL OF QUALYS VULNERABILITY AND PATCH MANAGEMENT SOLUTIONS SERVICES FOR THE PERIOD OF THREE (3) YEARS
//                       </p>
//                       <p className="mb-3">
//                         <a href="/Documents/SAMSA-110-2025-26_Panel-of-Researchers-Final.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                           <FaFilePdf style={{ marginRight: "5px" }} />SAMSA-110-2025-26_Panel of Researchers Final.pdf
//                         </a>
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Bid number</b>
//                         SAMSA/098/2023/24
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Advert date</b>

//                       </p>

//                       <p className="">
//                         <b className="d-block">Closing Date</b>
//                         No DATE
//                       </p>

//                       <p className="">
//                         <b className="d-block">LOCATION: SAMSA HEAD OFFICE</b><br />
//                         0146 Lunnon Road<br />Cnr Jan Shoba & Lunnon Road<br />HILLCREST<br />PRETORIA<br />0183
//                       </p>

//                     </div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab6"
//                   aria-expanded="false"
//                   aria-controls="blackTab6"
//                 >
//                   SAMSA/065/2023/24-APPOINTMENT OF A SUITABLE SERVICE PROVIDER/ (SUPPLIER) TO PROVIDE
//                 </button>
//               </h2>
//               <div
//                 id="blackTab6"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//               <div className="accordion-body">
//                   <p className="mb-3">
//                         <b className="d-block">​Description</b>
//                         THE APPOINTMENT OF A SERVICE PROVIDER (SUPPLIER) TO PROVIDE SAMSA MARITIME SPECIAL PROJECTS WITH TWO (2) X BOATS & TWO (2) TRAILERS, ON BEHALF OF THE MLRF
//                       </p>
//                       <p className="mb-3">
//                         <a href="/Documents/SAMSA-110-2025-26_Panel-of-Researchers-Final.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                           <FaFilePdf style={{ marginRight: "5px" }} />SAMSA-110-2025-26_Panel of Researchers Final.pdf
//                         </a>
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Bid number</b>
//                         SAMSA/065/2023/24
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Advert date</b>

//                       </p>

//                       <p className="">
//                         <b className="d-block">Closing Date</b>
//                         14 November 2023 at 11H00 a.m.
//                       </p>

//                       <p className="">
//                         <b className="d-block">LOCATION: SAMSA HEAD OFFICE</b><br />
//                         0146 Lunnon Road<br />Cnr Jan Shoba & Lunnon Road<br />HILLCREST<br />PRETORIA<br />0183
//                       </p>

//                     </div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab7"
//                   aria-expanded="false"
//                   aria-controls="blackTab7"
//                 >
//                   SAMSA/083/2023/24 THE APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS)
//                 </button>
//               </h2>
//               <div
//                 id="blackTab7"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//               <div className="accordion-body">
//                   <p className="mb-3">
//                         <b className="d-block">​Description</b>
//                         THE APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS) TO PROVIDE SAMSA MARITIME SPECIAL PROJECTS WITH HYDRAULIC AND PNEUMATIC SYSTEMS SERVICES FOR PORT ELIZABETH FOR A PERIOD NOT EXCEEDING 26 OCTOBER 2026 ON BEHALF OF THE MLRF
//                       </p>
//                       <p className="mb-3">
//                         <a href="/Documents/SAMSA-110-2025-26_Panel-of-Researchers-Final.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                           <FaFilePdf style={{ marginRight: "5px" }} />SAMSA-110-2025-26_Panel of Researchers Final.pdf
//                         </a>
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Bid number</b>
//                         SAMSA/083/2023/24
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Advert date</b>

//                       </p>

//                       <p className="">
//                         <b className="d-block">Closing Date</b>
//                         30/01/2024 at 11H00 a.m.
//                       </p>

//                       <p className="">
//                         <b className="d-block">LOCATION: SAMSA HEAD OFFICE</b><br />
//                         0146 Lunnon Road<br />Cnr Jan Shoba & Lunnon Road<br />HILLCREST<br />PRETORIA<br />0183
//                       </p>

//                     </div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab8"
//                   aria-expanded="false"
//                   aria-controls="blackTab8"
//                 >
//                   SAMSA/081/2023/24 THE APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS)
//                 </button>
//               </h2>
//               <div
//                 id="blackTab8"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//               <div className="accordion-body">
//                   <p className="mb-3">
//                         <b className="d-block">​Description</b>
//                         THE APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS) TO PROVIDE SAMSA MARITIME SPECIAL PROJECTS WITH HYDRAULIC AND PNEUMATIC SYSTEMS SERVICES FOR DURBAN FOR A PERIOD NOT EXCEEDING 26 OCTOBER 2026 ON BEHALF OF THE MLRF
//                       </p>
//                       <p className="mb-3">
//                         <a href="/Documents/SAMSA-110-2025-26_Panel-of-Researchers-Final.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                           <FaFilePdf style={{ marginRight: "5px" }} />SAMSA-110-2025-26_Panel of Researchers Final.pdf
//                         </a>
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Bid number</b>
//                         SAMSA/081/2023/24
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Advert date</b>

//                       </p>

//                       <p className="">
//                         <b className="d-block">Closing Date</b>
//                         30/01/2024 at 11H00 a.m.
//                       </p>

//                       <p className="">
//                         <b className="d-block">LOCATION: SAMSA HEAD OFFICE</b><br />
//                         0146 Lunnon Road<br />Cnr Jan Shoba & Lunnon Road<br />HILLCREST<br />PRETORIA<br />0183
//                       </p>

//                     </div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab9"
//                   aria-expanded="false"
//                   aria-controls="blackTab9"
//                 >
//                   SAMSA/079/2023/24: FOR THE APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS)
//                 </button>
//               </h2>
//               <div
//                 id="blackTab9"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//               <div className="accordion-body">
//                   <p className="mb-3">
//                         <b className="d-block">​Description</b>
//                         BID NO: SAMSA/079/2023/24: FOR THE APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS) TO PROVIDE SAMSA MARITIME SPECIAL PROJECTS WITH FISHING AND SEAMANSHIP GEAR - ROPES TACKLE NETS FOR PORTS ELIZABETH HABOUR A PERIOD NOT EXCEEDING 26 OCTOBER 2026 ON BEHALF OF THE MLRF.
//                       </p>
//                       <p className="mb-3">
//                         <a href="/Documents/SAMSA-110-2025-26_Panel-of-Researchers-Final.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                           <FaFilePdf style={{ marginRight: "5px" }} />SAMSA-110-2025-26_Panel of Researchers Final.pdf
//                         </a>
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Bid number</b>
//                         SAMSA/079/2023/24
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Advert date</b>

//                       </p>

//                       <p className="">
//                         <b className="d-block">Closing Date</b>
//                         30/01/ 2024 at 11H00 a.m.
//                       </p>

//                       <p className="">
//                         <b className="d-block">LOCATION: SAMSA HEAD OFFICE</b><br />
//                         0146 Lunnon Road<br />Cnr Jan Shoba & Lunnon Road<br />HILLCREST<br />PRETORIA<br />0183
//                       </p>

//                     </div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab10"
//                   aria-expanded="false"
//                   aria-controls="blackTab10"
//                 >
//                   	BID NO: SAMSA/078/2023/24: FOR THE APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS)
//                 </button>
//               </h2>
//               <div
//                 id="blackTab10"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//               <div className="accordion-body">
//                   <p className="mb-3">
//                         <b className="d-block">​Description</b>
//                         BID NO: SAMSA/078/2023/24: FOR THE APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS) TO PROVIDE SAMSA MARITIME SPECIAL PROJECTS WITH FISHING AND SEAMANSHIP GEAR - ROPES TACKLE NETS FOR EAST LONDON HABOUR A PERIOD NOT EXCEEDING 26 OCTOBER 2026 ON BEHALF OF THE MLRF.
//                       </p>
//                       <p className="mb-3">
//                         <a href="/Documents/SAMSA-110-2025-26_Panel-of-Researchers-Final.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                           <FaFilePdf style={{ marginRight: "5px" }} />SAMSA-110-2025-26_Panel of Researchers Final.pdf
//                         </a>
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Bid number</b>
//                         SAMSA/078/2023/24
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Advert date</b>

//                       </p>

//                       <p className="">
//                         <b className="d-block">Closing Date</b>
//                         30/01/ 2024 at 11H00 a.m.
//                       </p>

//                       <p className="">
//                         <b className="d-block">LOCATION: SAMSA HEAD OFFICE</b><br />
//                         0146 Lunnon Road<br />Cnr Jan Shoba & Lunnon Road<br />HILLCREST<br />PRETORIA<br />0183
//                       </p>

//                     </div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab11"
//                   aria-expanded="false"
//                   aria-controls="blackTab11"
//                 >
//                   SAMSA-097-2023-24THE APPOINTMENT OF AN ACCREDITED SERVICE PROVIDERS FOR THE RENEWAL
//                 </button>
//               </h2>
//               <div
//                 id="blackTab11"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//               <div className="accordion-body">
//                   <p className="mb-3">
//                         <b className="d-block">​Description</b>
//                         THE APPOINTMENT OF AN ACCREDITED SERVICE PROVIDERS FOR THE RENEWAL OF CROWDSTRIKE NEXT GENERATION ANTIVIRUS SOLUTION LICENCE AND SUPPORT SERVICES FOR THE PERIOD OF THREE (3) YEARS
//                       </p>
//                       <p className="mb-3">
//                         <a href="/Documents/SAMSA-110-2025-26_Panel-of-Researchers-Final.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                           <FaFilePdf style={{ marginRight: "5px" }} />SAMSA-110-2025-26_Panel of Researchers Final.pdf
//                         </a>
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Bid number</b>
//                         SAMSA/097/2023/24
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Advert date</b>

//                       </p>

//                       <p className="">
//                         <b className="d-block">Closing Date</b>

//                       </p>

//                       <p className="">
//                         <b className="d-block">LOCATION: SAMSA HEAD OFFICE</b><br />
//                         0146 Lunnon Road<br />Cnr Jan Shoba & Lunnon Road<br />HILLCREST<br />PRETORIA<br />0183
//                       </p></div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab12"
//                   aria-expanded="false"
//                   aria-controls="blackTab12"
//                 >
//                   SAMSA/082/2023/24 THE APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS)
//                 </button>
//               </h2>
//               <div
//                 id="blackTab12"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//               <div className="accordion-body">
//                   <p className="mb-3">
//                         <b className="d-block">​Description</b>
//                         THE APPOINTMENT OF A PANEL OF SERVICE PROVIDERS FOR SAMSA MARITIME SPECIAL PROJECT WITH THE HYDRAULIC AND PNEUMATIC SYSTEMS SERVICE FOR EAST LONDON FOR A PERIOD NOT EXCEEDING 26 OCTOBER 2026
//                       </p>
//                       <p className="mb-3">
//                         <a href="/Documents/SAMSA-110-2025-26_Panel-of-Researchers-Final.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                           <FaFilePdf style={{ marginRight: "5px" }} />SAMSA-110-2025-26_Panel of Researchers Final.pdf
//                         </a>
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Bid number</b>
//                         SAMSA/082/2023/24
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Advert date</b>

//                       </p>

//                       <p className="">
//                         <b className="d-block">Closing Date</b>
//                         30/01/2024 at 11H00 a.m.
//                       </p>

//                       <p className="">
//                         <b className="d-block">LOCATION: SAMSA HEAD OFFICE</b><br />
//                         0146 Lunnon Road<br />Cnr Jan Shoba & Lunnon Road<br />HILLCREST<br />PRETORIA<br />0183
//                       </p></div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab13"
//                   aria-expanded="false"
//                   aria-controls="blackTab13"
//                 >
//                   SAMSA/080/2023/24 THE APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS)
//                </button>
//               </h2>
//               <div
//                 id="blackTab13"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//               <div className="accordion-body">
//                   <p className="mb-3">
//                         <b className="d-block">​Description</b>
//                         THE APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS) TO PROVIDE SAMSA MARITIME SPECIAL PROJECTS WITH HYDRAULIC AND PNEUMATIC SYSTEMS SERVICES FOR CAPE TOWN FOR A PERIOD NOT EXCEEDING 26 OCTOBER 2026 ON BEHALF OF THE MLRF
//                       </p>
//                       <p className="mb-3">
//                         <a href="/Documents/SAMSA-110-2025-26_Panel-of-Researchers-Final.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                           <FaFilePdf style={{ marginRight: "5px" }} />SAMSA-110-2025-26_Panel of Researchers Final.pdf
//                         </a>
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Bid number</b>
//                         SAMSA/080/2023/24
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Advert date</b>

//                       </p>

//                       <p className="">
//                         <b className="d-block">Closing Date</b>
//                         30/01/2024 at 11H00 a.m.
//                       </p>

//                       <p className="">
//                         <b className="d-block">LOCATION: SAMSA HEAD OFFICE</b><br />
//                         0146 Lunnon Road<br />Cnr Jan Shoba & Lunnon Road<br />HILLCREST<br />PRETORIA<br />0183
//                       </p></div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab14"
//                   aria-expanded="false"
//                   aria-controls="blackTab14"
//                 >
//                   BID NO: SAMSA/076/2023/24: FOR THE APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS)
//                 </button>
//               </h2>
//               <div
//                 id="blackTab14"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//               <div className="accordion-body">
//                   <p className="mb-3">
//                         <b className="d-block">​Description</b>
//                         BID NO: SAMSA/076/2023/24: FOR THE APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS) TO PROVIDE SAMSA MARITIME SPECIAL PROJECTS WITH FISHING AND SEAMANSHIP GEAR - ROPES TACKLE NETS FOR CAPE TOWN HABOUR A PERIOD NOT EXCEEDING 26 OCTOBER 2026 ON BEHALF OF THE MLRF.
//                       </p>
//                       <p className="mb-3">
//                         <a href="/Documents/SAMSA-110-2025-26_Panel-of-Researchers-Final.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                           <FaFilePdf style={{ marginRight: "5px" }} />SAMSA-110-2025-26_Panel of Researchers Final.pdf
//                         </a>
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Bid number</b>
//                         SAMSA/076/2023/24
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Advert date</b>

//                       </p>

//                       <p className="">
//                         <b className="d-block">Closing Date</b>
//                         30/01/2024 at 11H00 a.m.
//                       </p>

//                       <p className="">
//                         <b className="d-block">LOCATION: SAMSA HEAD OFFICE</b><br />
//                         0146 Lunnon Road<br />Cnr Jan Shoba & Lunnon Road<br />HILLCREST<br />PRETORIA<br />0183
//                       </p></div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab15"
//                   aria-expanded="false"
//                   aria-controls="blackTab15"
//                 >
//                   APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS) TO PROVIDE SAMSA MARITIME SPECIAL
//                 </button>
//               </h2>
//               <div
//                 id="blackTab15"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//               <div className="accordion-body">
//                   <p className="mb-3">
//                         <b className="d-block">​Description</b>
//                         APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS) TO PROVIDE SAMSA MARITIME SPECIAL PROJECTS WITH AIR CONDITIONING AND    SYSTEMS SERVICES EAST LONDON FOR A PERIOD NOT EXCEEDING 26 OCTOBER 2026 ON BEHALF OF THE MLRF
//                       </p>
//                       <p className="mb-3">
//                         <a href="/Documents/SAMSA-110-2025-26_Panel-of-Researchers-Final.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                           <FaFilePdf style={{ marginRight: "5px" }} />SAMSA-110-2025-26_Panel of Researchers Final.pdf
//                         </a>
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Bid number</b>
//                         SAMSA/075/2023/24
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Advert date</b>

//                       </p>

//                       <p className="">
//                         <b className="d-block">Closing Date</b>
//                         30/01/2024 at 11H00 a.m.
//                       </p>

//                       <p className="">
//                         <b className="d-block">LOCATION: SAMSA HEAD OFFICE</b><br />
//                         0146 Lunnon Road<br />Cnr Jan Shoba & Lunnon Road<br />HILLCREST<br />PRETORIA<br />0183
//                       </p></div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab16"
//                   aria-expanded="false"
//                   aria-controls="blackTab16"
//                 >
//                   SAMSA/074/2023/24-APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS)
//                 </button>
//               </h2>
//               <div
//                 id="blackTab16"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//               <div className="accordion-body">
//                   <p className="mb-3">
//                         <b className="d-block">​Description</b>
//                         APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS) TO PROVIDE SAMSA MARITIME SPECIAL PROJECTS WITH AIR CONDITIONING AND    SYSTEMS SERVICES PORT ELIZABETH FOR A PERIOD NOT EXCEEDING 26 OCTOBER 2026 ON BEHALF OF THE MLRF
//                       </p>
//                       <p className="mb-3">
//                         <a href="/Documents/SAMSA-110-2025-26_Panel-of-Researchers-Final.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                           <FaFilePdf style={{ marginRight: "5px" }} />SAMSA-110-2025-26_Panel of Researchers Final.pdf
//                         </a>
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Bid number</b>
//                         SAMSA/074/2023/24
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Advert date</b>

//                       </p>

//                       <p className="">
//                         <b className="d-block">Closing Date</b>
//                         30/01/2024 at 11H00 a.m.
//                       </p>

//                       <p className="">
//                         <b className="d-block">LOCATION: SAMSA HEAD OFFICE</b><br />
//                         0146 Lunnon Road<br />Cnr Jan Shoba & Lunnon Road<br />HILLCREST<br />PRETORIA<br />0183
//                       </p></div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab17"
//                   aria-expanded="false"
//                   aria-controls="blackTab17"
//                 >
//                   SAMSA-073-2023-24 - APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS)
//                 </button>
//               </h2>
//               <div
//                 id="blackTab17"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//               <div className="accordion-body">
//                   <p className="mb-3">
//                         <b className="d-block">​Description</b>
//                         APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS) TO PROVIDE SAMSA MARITIME SPECIAL PROJECTS WITH AIR CONDITIONING AND    SYSTEMS SERVICES CAPE TOWN FOR A PERIOD NOT EXCEEDING 26 OCTOBER 2026 ON BEHALF OF THE MLRF
//                       </p>
//                       <p className="mb-3">
//                         <a href="/Documents/SAMSA-110-2025-26_Panel-of-Researchers-Final.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                           <FaFilePdf style={{ marginRight: "5px" }} />SAMSA-110-2025-26_Panel of Researchers Final.pdf
//                         </a>
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Bid number</b>
//                         SAMSA/073/2023/24
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Advert date</b>

//                       </p>

//                       <p className="">
//                         <b className="d-block">Closing Date</b>
//                         30/01/2024 at 11H00 a.m.
//                       </p>

//                       <p className="">
//                         <b className="d-block">LOCATION: SAMSA HEAD OFFICE</b><br />
//                         0146 Lunnon Road<br />Cnr Jan Shoba & Lunnon Road<br />HILLCREST<br />PRETORIA<br />0183
//                       </p></div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab18"
//                   aria-expanded="false"
//                   aria-controls="blackTab18"
//                 >
//                   SAMSA/072/2023/24 -APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS)
//                 </button>
//               </h2>
//               <div
//                 id="blackTab18"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//               <div className="accordion-body">
//                   <p className="mb-3">
//                         <b className="d-block">​Description</b>
//                         APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS) TO PROVIDE SAMSA MARITIME SPECIAL PROJECTS WITH AIR CONDITIONING AND    SYSTEMS SERVICES DURBAN FOR A PERIOD NOT EXCEEDING 26 OCTOBER 2026 ON BEHALF OF THE MLRF
//                       </p>
//                       <p className="mb-3">
//                         <a href="/Documents/SAMSA-110-2025-26_Panel-of-Researchers-Final.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                           <FaFilePdf style={{ marginRight: "5px" }} />SAMSA-110-2025-26_Panel of Researchers Final.pdf
//                         </a>
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Bid number</b>
//                         SAMSA/072/2023/24
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Advert date</b>

//                       </p>

//                       <p className="">
//                         <b className="d-block">Closing Date</b>
//                         30/01/2024 at 11H00 a.m.
//                       </p>

//                       <p className="">
//                         <b className="d-block">LOCATION: SAMSA HEAD OFFICE</b><br />
//                         0146 Lunnon Road<br />Cnr Jan Shoba & Lunnon Road<br />HILLCREST<br />PRETORIA<br />0183
//                       </p></div>
//               </div>
//             </div>
//             <div className="accordion-item">
//               <h2 className="accordion-header">
//                 <button
//                   className="accordion-button collapsed"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#blackTab19"
//                   aria-expanded="false"
//                   aria-controls="blackTab19"
//                 >
//                   SAMSA/072/2023/24 -APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS)
//                 </button>
//               </h2>
//               <div
//                 id="blackTab18"
//                 className="accordion-collapse collapse"
//                 data-bs-parent="#blackTab"
//               >
//               <div className="accordion-body">
//                   <p className="mb-3">
//                         <b className="d-block">​Description</b>
//                         APPOINTMENT OF A PANEL OF SERVICE PROVIDERS (SUPPLIERS) TO PROVIDE SAMSA MARITIME SPECIAL PROJECTS WITH AIR CONDITIONING AND    SYSTEMS SERVICES DURBAN FOR A PERIOD NOT EXCEEDING 26 OCTOBER 2026 ON BEHALF OF THE MLRF
//                       </p>
//                       <p className="mb-3">
//                         <a href="/Documents/SAMSA-110-2025-26_Panel-of-Researchers-Final.pdf" target="_blank" rel="noopener noreferrer" className="pdf-link" >
//                           <FaFilePdf style={{ marginRight: "5px" }} />SAMSA-110-2025-26_Panel of Researchers Final.pdf
//                         </a>
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Bid number</b>
//                         SAMSA/072/2023/24
//                       </p>

//                       <p className="mb-3">
//                         <b className="d-block">Advert date</b>

//                       </p>

//                       <p className="">
//                         <b className="d-block">Closing Date</b>
//                         30/01/2024 at 11H00 a.m.
//                       </p>

//                       <p className="">
//                         <b className="d-block">LOCATION: SAMSA HEAD OFFICE</b><br />
//                         0146 Lunnon Road<br />Cnr Jan Shoba & Lunnon Road<br />HILLCREST<br />PRETORIA<br />0183
//                       </p>

//                     </div>


//                   </div>

//                 </div>
//               </div>
//             </div>
//           </div>










//         <div className="col-12">
//           {loading ? (
//             <div>Loading Tenders...</div>
//           ) : (
//             <ul className="strip-ul mt-3">
//               {Object.entries(groupedDocs).map(([folderName, docs], index) => (
//                 <li className="bg-transparent p-0" key={index}>
//                   <div className="row g-4">
//                     {/* <div className="col-auto">
//                       <img src={pdfIcon} alt="PDF icon" />
//                     </div> */}
//                     <div className="col">
//                       <div className="row g-4">
//                         <div className="col-md">
//                           {/* <div className="font-18 font-600">Tenders Name</div> */}
//                           <div className="font-16 font-400">
//                             {/* <p className="text-orange-ef3e33 text-uppercase">{folderName}</p> */}
//                             {/* <ul className="list">
//                               {docs.map((item, i) => (
//                                 <li key={i}>
//                                   <a
//                                     href={`${WebApiURL}File/view/${encodeURIComponent(item.fileId)}`}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                   >
//                                     {item.fileName}
//                                   </a>
//                                 </li>
//                               ))}
//                             </ul> */}
//                           </div>
//                         </div>
//                         {/* <div className="col-md-auto">
//                           <div className="font-18 font-600">Tender Opening Date</div>
//                           <div className="font-16 font-400">
//                             {docs[0]?.modifiedDate ? new Date(docs[0].modifiedDate).toLocaleString() : '—'}
//                           </div>
//                         </div>
//                          <div className="col-md-auto">
//                           <div className="font-18 font-600">Tender Closing Date</div>
//                           <div className="font-16 font-400">
//                             {docs[0]?.modifiedDate ? new Date(docs[0].modifiedDate).toLocaleString() : '—'}
//                           </div>
//                         </div> */}
//                       </div>
//                     </div>
//                   </div>
//                 </li>
//               ))}
//             </ul>
//           )}
//         </div>

//     </>
//   );
// }



// export default CancelledTenders;


// New Code With API DATA

// import React, { useEffect, useState } from "react";
// import { useFileContext } from "./../../Contexts/FileContext";
// import { WebApiURL } from "./../../Constants/Constants";

// function CancelledTenders() {
//     const { setComponentName, setSection } = useFileContext();
//     const [tenders, setTenders] = useState([]);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         setComponentName("ALL FORMS");
//         setSection("");

//         // ✅ Fetch tenders from backend API
//         const fetchTenders = async () => {
//             try {
//                 const response = await fetch(`${WebApiURL}Tender/all`);
//                 const data = await response.json();

//                 console.log("Data returned from backend", data);

//                 // ✅ Only keep cancelled Tenders
//     const cancelled = (data || []).filter(
//       (t) => t.component === "Cancelled Tenders"
//     );

//                 setTenders(cancelled || []);
//             } catch (error) {
//                 console.error("Error fetching tenders:", error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchTenders();
//     }, [setComponentName, setSection]);

//     const tableStyle = {
//         width: "100%",
//         borderCollapse: "collapse",
//         fontFamily: "Arial, sans-serif",
//     };

//     const thStyle = {
//         backgroundColor: "#008B8B", // Teal header
//         color: "white",
//         padding: "10px",
//         textAlign: "left",
//         fontWeight: "bold",
//         border: "1px solid #ccc",
//     };

//     const tdStyle = {
//         padding: "10px",
//         border: "1px solid #ccc",
//     };

//     const rowEven = { backgroundColor: "#F9F9F9" };

//     return (
//         <>
//             <div className="service-title font-700 mb-3 text-uppercase">
//                 Cancelled
//                 <span className="text-orange-ef3e33 font-400"> Tenders </span>
//             </div>

//             {loading ? (
//                 <div>Loading Tenders...</div>
//             ) : (
//                 <div className="row g-3 g-sm-4 g-md-4">
//                     <div className="col-12">
//                         <div className="accordion blackTab" id="blackTab">
//                             {tenders.map((tender, index) => (
//                                 <div className="accordion-item" key={index}>
//                                     {/* <h2 className="accordion-header">
//                                         <button
//                                             className="accordion-button collapsed"
//                                             type="button"
//                                             data-bs-toggle="collapse"
//                                             data-bs-target={`#tender-${index}`}
//                                             aria-expanded="false"
//                                             aria-controls={`tender-${index}`}
//                                         >
//                                             {tender.section }

//                                         </button>
//                                     </h2> */}
//                                     <h2 className="accordion-header">
//                                         <button
//                                             className="accordion-button collapsed"
//                                             type="button"
//                                             data-bs-toggle="collapse"
//                                             data-bs-target={`#tender-${index}`}
//                                             aria-expanded="false"
//                                             aria-controls={`tender-${index}`}
//                                         >
//                                             <div className="row w-100 m-0">
//                                                 {/* Section Name */}
//                                                 <div className="col-12 col-md-6 fw-semibold">
//                                                     <span>{tender.section}</span>
//                                                 </div>

//                                                 {/* Open Date */}
//                                                 <div className="col-12 col-md-2 text-md">
//                                                     <span className="d-none d-md-inline fw-semibold">Open Date: </span><br />
//                                                     <span>
//                                                         {tender.openDate && !isNaN(new Date(tender.openDate))
//                                                             ? new Date(tender.openDate).toLocaleDateString("en-GB")
//                                                             : ""}
//                                                     </span>
//                                                 </div>

//                                                 {/* Closing Date & Time */}
//                                                 <div className="col-12 col-md-3 text-md">
//                                                     <span className="d-none d-md-inline fw-semibold">Close Date & Time: </span><br />
//                                                     <span>
//                                                         {tender.closingDate && !isNaN(new Date(tender.closingDate))
//                                                             ? new Date(tender.closingDate).toLocaleString("en-GB", {
//                                                                 day: "2-digit",
//                                                                 month: "2-digit",
//                                                                 year: "numeric",
//                                                                 hour: "2-digit",
//                                                                 minute: "2-digit"
//                                                             })
//                                                             : ""}
//                                                     </span>
//                                                 </div>

//                                                 {/* Status */}
//                                                 <div className="col-12 col-md-1 text-md-end">
//                                                     <span className="d-none d-md-inline fw-semibold">Status: </span><br />
//                                                     <span>{tender.status || ""}</span>
//                                                 </div>
//                                             </div>
//                                         </button>
//                                     </h2>
//                                     <div
//                                         id={`tender-${index}`}
//                                         className="accordion-collapse collapse"
//                                         data-bs-parent="#blackTab"
//                                     >
//                                         <div style={{ padding: "2px" }}>



//                                             <div dangerouslySetInnerHTML={{ __html: tender.fileHTMLContent }} />



//                                         </div>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// }

// export default CancelledTenders;

// New Code With Print and Search
import React, { useEffect, useState, useRef, useMemo } from "react";
import { useFileContext } from "./../../Contexts/FileContext";
import { WebApiURL } from "./../../Constants/Constants";

function CancelledTenders() {
    const { setComponentName, setSection } = useFileContext();
    const [tenders, setTenders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const printRef = useRef(null);

    useEffect(() => {
        setComponentName("ALL FORMS");
        setSection("");

        const fetchTenders = async () => {
            try {
                const response = await fetch(`${WebApiURL}Tender/all`);
                const data = await response.json();

                // ✅ Only keep Cancelled Tenders
                const cancelled = (data || []).filter(
                    (t) => t.component === "Cancelled Tenders"
                );

                setTenders(cancelled || []);
            } catch (error) {
                console.error("Error fetching tenders:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchTenders();
    }, [setComponentName, setSection]);

    // 🔍 Filter tenders by section, status, open date, closing date
    const filteredTenders = useMemo(() => {
        if (!searchTerm) return tenders;
        const term = searchTerm.toLowerCase();

        return tenders.filter((t) => {
            const section = (t.section || "").toString().toLowerCase();
            const status = (t.status || "").toString().toLowerCase();

            const openDateStr =
                t.openDate && !isNaN(new Date(t.openDate))
                    ? new Date(t.openDate)
                        .toLocaleString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                        })
                        .toLowerCase()
                    : "";

            const closingDateStr =
                t.closingDate && !isNaN(new Date(t.closingDate))
                    ? new Date(t.closingDate)
                        .toLocaleString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                        })
                        .toLowerCase()
                    : "";

            return (
                section.includes(term) ||
                status.includes(term) ||
                openDateStr.includes(term) ||
                closingDateStr.includes(term)
            );
        });
    }, [searchTerm, tenders]);

    // 🖨️ Print handler
    const handlePrint = () => {
        if (!printRef.current) return;
        const printContent = printRef.current.innerHTML;
        const newWindow = window.open("", "", "width=1200,height=650");
        newWindow.document.write(`
      <html>
        <head>
          <title>Print Preview - Cancelled Tenders</title>
       <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            .accordion-button { background: #f8f9fa; font-weight: bold; }
            .accordion-item { border: 1px solid #ddd; margin-bottom: 10px; border-radius: 6px; }
            .accordion-body { padding: 10px 20px; }
            .tender-header { display: none !important; }
            .accordion-button { display: block; text-align: left; width: 100%; }
          </style>
        </head>
        <body>${printContent}</body>
      </html>
    `);
        newWindow.document.close();
        newWindow.focus();
        newWindow.print();
        newWindow.close();
    };

    return (
        <>
            {/* Header and Search/Print Controls */}
            <div className="service-title font-700 mb-3 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2">
                <div>
                    Cancelled <span className="text-orange-ef3e33 font-400">Tenders</span>
                </div>

                <div className="d-flex flex-wrap gap-2">
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        style={{ width: "260px" }}
                        placeholder="Search by section, status, or date..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <button
                        className="about-btn btn-green-38B652 text-decoration-none"
                        onClick={handlePrint}
                    >
                        Print
                    </button>
                </div>
            </div>

            {/* Main Accordion Display */}
            {loading ? (
                <div>Loading Tenders...</div>
            ) : filteredTenders.length === 0 ? (
                <div>No matching tenders found.</div>
            ) : (
                <div className="row g-3 g-sm-4 g-md-4" ref={printRef}>
                    <div className="col-12">
                        <div className="accordion blackTab" id="blackTab">
                            {filteredTenders.map((tender, index) => (
                                <div className="accordion-item" key={index}>
                                    <h2 className="accordion-header">
                                        <button
                                            className="accordion-button collapsed"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={`#tender-${index}`}
                                            aria-expanded="false"
                                            aria-controls={`tender-${index}`}
                                        >
                                            <div className="row w-100 m-0">
                                                {/* Section */}
                                                <div className="col-12 col-md-6 fw-semibold">
                                                    <span>{tender.bidNumber}</span><br />
                                                    <span>{tender.section}</span>
                                                </div>

                                                {/* Open Date */}
                                                <div className="col-12 col-md-2 text-md">
                                                    <span className="d-none d-md-inline fw-semibold">
                                                        Open Date:
                                                    </span>
                                                    <br />
                                                    <span>
                                                        {tender.openDate &&
                                                            !isNaN(new Date(tender.openDate))
                                                            ? new Date(
                                                                tender.openDate
                                                            ).toLocaleDateString("en-GB")
                                                            : ""}
                                                    </span>
                                                </div>

                                                {/* Close Date */}
                                                <div className="col-12 col-md-3 text-md">
                                                    <span className="d-none d-md-inline fw-semibold">
                                                        Close Date & Time:
                                                    </span>
                                                    <br />
                                                    <span>
                                                        {tender.closingDate &&
                                                            !isNaN(new Date(tender.closingDate))
                                                            ? new Date(
                                                                tender.closingDate
                                                            ).toLocaleString("en-GB", {
                                                                day: "2-digit",
                                                                month: "2-digit",
                                                                year: "numeric",
                                                                hour: "2-digit",
                                                                minute: "2-digit",
                                                            })
                                                            : ""}
                                                    </span>
                                                </div>

                                                {/* Status */}
                                                <div className="col-12 col-md-1 text-md-end">
                                                    <span className="d-none d-md-inline fw-semibold">
                                                        Status:
                                                    </span>
                                                    <br />
                                                    <span>{tender.status || ""}</span>
                                                </div>
                                            </div>
                                        </button>
                                    </h2>

                                    <div
                                        id={`tender-${index}`}
                                        className="accordion-collapse collapse"
                                        data-bs-parent="#blackTab"
                                    >
                                        <div style={{ padding: "8px" }}>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: tender.fileHTMLContent,
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default CancelledTenders;

